import type { TooltipProps } from '@mui/material/Tooltip';

/** טולטיפ עזרה לבן עם טקסט אפור — כמו ContextualInfoPopover */
export const lightHelpTooltipSlotProps: TooltipProps['slotProps'] = {
  tooltip: {
    sx: (theme) => ({
      maxWidth: 340,
      py: 1,
      px: 1.25,
      bgcolor: 'background.paper',
      color: 'text.secondary',
      border: '1px solid',
      borderColor: 'divider',
      boxShadow: theme.shadows[4],
      fontSize: '0.8125rem',
      lineHeight: 1.5,
      fontWeight: 400,
    }),
  },
  arrow: {
    sx: (theme) => ({
      color: theme.palette.background.paper,
    }),
  },
};
